import { Injectable } from '@angular/core'

import { BehaviorSubject, Observable } from "rxjs";
import { ILoginInfo, LoginInfo } from '@models'

import { BaseService } from './base.service'

@Injectable()
export class StatusService extends BaseService {

  private ACCESS_TOKEN_PROPERTY : string = 'access_token'
  private REMEMBER_ME_PROPERTY : string = 'remember_me'
  private LANG_CODE_PROPERTY : string = 'lang_code'
  private BASKET_PROPERTY : string = 'basket'

  private DEFAULT_LANG = 'it'
  private rememberMe: boolean = false
  private isLoggedInSubject = new BehaviorSubject<boolean>(false)
  private loginInfoSubject = new BehaviorSubject<ILoginInfo>({})
  private languageCode = new BehaviorSubject(undefined)
  private loggedOutSubject = new BehaviorSubject(false)

  constructor() {
    super();
    // remember_me can be true only in localStorage and determines the active storage
    this.rememberMe = localStorage.getItem(this.REMEMBER_ME_PROPERTY) === 'true'
    this.languageCode.next(this.storage.getItem(this.LANG_CODE_PROPERTY) || this.DEFAULT_LANG)
  }

  get storage() {
    return this.rememberMe ? localStorage : sessionStorage
  }

  isLoggedIn() : Observable<boolean> {
    return this.isLoggedInSubject.asObservable()
  }

  getLoginInfo() : Observable<ILoginInfo> {
    return this.loginInfoSubject.asObservable()
  }

  setLoginInfo(loginInfo: ILoginInfo) : void {
    this.loginInfoSubject.next(new LoginInfo(loginInfo))
    this.isLoggedInSubject.next(true)
  }

  logout() : void {
    this.loginInfoSubject.next({})
    this.isLoggedInSubject.next(false);
    this.cleanStorages()
    this.loggedOutSubject.next(true)
  }

  cleanStorages() {
    [
      localStorage,
      sessionStorage
    ].forEach(storage => {
        [
          this.ACCESS_TOKEN_PROPERTY,
          this.REMEMBER_ME_PROPERTY,
          this.REMEMBER_ME_PROPERTY,
          this.BASKET_PROPERTY,
        ].forEach(prop => storage.removeItem(prop))
      })
  }

  setAccessToken(accessToken: string, rememberMe: any) : void {
    this.rememberMe = rememberMe;
    this.storage.setItem(this.REMEMBER_ME_PROPERTY, rememberMe)
    this.storage.setItem(this.ACCESS_TOKEN_PROPERTY, accessToken)
  }

  getAccessToken() : string {
    return this.storage.getItem(this.ACCESS_TOKEN_PROPERTY)
  }

  setLanguageCode(languageCode: any) {
    this.languageCode.next(languageCode);
    this.storage.setItem('languageCode', languageCode)
    console.log('set localStorage languageCode', localStorage.getItem('languageCode'))
  }

  getLanguageCode() {
    return this.languageCode
  }

  setBasketItems(basketItems: any) {
    this.storage.setItem(this.BASKET_PROPERTY, JSON.stringify(basketItems))
  }
  getBasketItems() {
    const basketString = this.storage.getItem(this.BASKET_PROPERTY)
    try {
      return JSON.parse(basketString) || []
    } catch (error) {
      return []
    }
  }

  getLoggedOut() {
    return this.loggedOutSubject
  }
}
